import classnames from "classnames";
import { usePricingExplorer } from "./PricingExplorerContext";
import styles from "./pricing-explorer.module.scss";

interface CoachingScaleProps {
  labelStart?: string;
  labelEnd?: string;
}

export const CoachingScale = ({
  labelStart = "Self-guided coaching",
  labelEnd = "Fully 1:1 coaching",
}: CoachingScaleProps) => {
  const { selectedPlanIndex, selectPlan, hoveredPlanIndex, planCount } =
    usePricingExplorer();

  const activeDotIndex = hoveredPlanIndex ?? selectedPlanIndex;
  const steps = Array.from({ length: planCount }, (_, i) => i);

  return (
    <div className={styles.coachingScale}>
      <div className={styles.coachingScaleLabels}>
        <span>{labelStart}</span>
        <span>{labelEnd}</span>
      </div>
      <div
        className={styles.coachingScaleTrack}
        role="radiogroup"
        aria-label="Coaching level"
      >
        {steps.map((i) => (
          <button
            key={i}
            type="button"
            role="radio"
            aria-checked={selectedPlanIndex === i}
            aria-label={`Plan ${i + 1}`}
            className={classnames(styles.coachingScaleStep, {
              [styles.coachingScaleStepHovered]: activeDotIndex === i,
            })}
            onClick={() => selectPlan(i)}
          />
        ))}
      </div>
    </div>
  );
};
